import styled from 'styled-components/macro';

export const SplashContainer = styled.section`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const SplashTitle = styled.h2`
`;
